import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "gift-listing-section__caption" }
const _hoisted_3 = {
  key: 0,
  class: "gift-listing-section__more-products"
}
const _hoisted_4 = { class: "gift-listing-section__caption-bottom category-subtitle" }
const _hoisted_5 = { class: "gift-listing-section__more-products-caption highlight" }
const _hoisted_6 = ["disabled"]

import { ref, computed } from 'vue';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import {
  generateHtmlElementId,
  getContext
} from '@/composables/useGiftProductListing';
import useGiftCard from '@/composables/useGiftCard';
import ProductCard from '../ProductCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GiftListingSection',
  props: {
  section: {
    type: Object,
    required: true
  },
  highlightSide: {
    type: String,
    default: ''
  },
},
  setup(__props) {

const props = __props;

const { page, route } = useContext();
const { websiteText } = useWebsiteTexts();
const { activeGiftCard } = useGiftCard();
const { isLoadingGiftProducts, loadAllSectionProducts, isSingleSection } =
  getContext();

const error = ref('');

const highlightProductClass = computed(() => {
  if (!props.highlightSide) {
    return '';
  }
  return `gift-listing-section__highlight-${props.highlightSide}`;
});

const productSection = ref(props.section);

const products = computed(() => {
  const productList = productSection.value?.products || [];

  if (productList?.[0] && props.highlightSide) {
    productList[0].highlighted = true;
  }

  return productList?.sort((a, b) => a.createdDate - b.createdDate);
});

const shouldRender = computed(() => {
  return products.value?.length > 0;
});

const categoryId = computed(() => {
  return route.query?.category || page.value.dataJson?.dataJson?.category?.systemId;
});

const tag = computed(() => {
  return productSection.value?.tags?.[0];
});

const sectionLinkId = computed(() => {
  return `${generateHtmlElementId(tag.value?.value || '')}`;
});

const sectionCaption = computed(() => {
  if (isSingleSection) {
    return tag.value.displayName || '';
  }

  return tag.value.displayName || tag.value.value || '';
});

const displayLoadMoreProducts = computed(() => {
  return (
    (productSection.value?.canLoadMoreProducts &&
      productSection.value?.take < productSection.value?.totalHits) ||
    false
  );
});

const productsLeftToDisplayCaption = computed(() => {
  const highlightTake = props.highlightSide
    ? productSection.value?.take - 3
    : productSection.value?.take;

  const left = productSection.value?.totalHits - highlightTake || 0;

  return websiteText(
    'getmygift__productlisting__productslefttodisplay'
  ).value?.replace('{0}', left);
});

async function triggerLoadAllProducts() {
  try {
    const activeSection = document.location.href.substring(
      document.location.href.indexOf('#')
    );
    if (activeSection) {
      history.replaceState(
        {},
        '',
        document.location.href.substring(0, document.location.href.indexOf('#'))
      );
    }

    await loadAllSectionProducts({
      categorySystemId: categoryId.value,
      section: {
        take: 999,
        tags: (productSection.value.tags || []).map((t: any) => {
          return {
            key: t.key,
            value: t.value
          };
        })
      }
    });
  } catch (err: any) {
    error.value = err;
  }
}

function pushSelectItemEvent(product) {
  if (typeof window.dataLayer === 'undefined' || !categoryId) {
    return;
  }
  const dataToPush = {
    event: productSection.value?.isPopularSection  ? 'select_item_recommendations' : 'select_item',
    item_list_id: `category_${categoryId.value}`,
    item_list_name: `Category: ${page.value.dataJson?.dataJson?.category?.googleAnalyticsName}`,
    items: [
      {
        item_id: product?.articleNumber || '',
        item_name:
          product?.googleAnalyticsName ||
          product?.productName ||
          product?.name ||
          '',
        item_brand: product?.brandName,
        quantity: 1,
        item_list_id: `category_${categoryId.value}`,
        item_list_name: `Category: ${page.value.dataJson?.dataJson?.category?.googleAnalyticsName}`
      }
    ]
  };

  window.dataLayer.push(dataToPush);
}

const showFavoriteProducts = computed(() => {
  return activeGiftCard?.value?.giftCards?.length > 0;
})

function isFavoriteProduct(productId) {
  return activeGiftCard?.value?.favoriteProductIds?.includes(productId);
}


return (_ctx: any,_cache: any) => {
  return (shouldRender.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "gift-listing-section",
        id: sectionLinkId.value
      }, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(sectionCaption.value), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["gift-listing-section__product-list", highlightProductClass.value])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product, index) => {
            return (_openBlock(), _createBlock(ProductCard, {
              key: product,
              product: product,
              tag: tag.value,
              "category-id": categoryId.value,
              isFavoriteProduct: isFavoriteProduct(product.articleNumber),
              showFavoriteProducts: showFavoriteProducts.value,
              onClick: ($event: any) => (pushSelectItemEvent(product))
            }, null, 8, ["product", "tag", "category-id", "isFavoriteProduct", "showFavoriteProducts", "onClick"]))
          }), 128))
        ], 2),
        (displayLoadMoreProducts.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(sectionCaption.value), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(productsLeftToDisplayCaption.value), 1),
              _createElementVNode("button", {
                class: "btn-primary gift-listing-section__more-products-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (triggerLoadAllProducts())),
                disabled: _unref(isLoadingGiftProducts)
              }, _toDisplayString(_unref(websiteText)('getmygift__productlisting__loadmoreproducts').value), 9, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})